import React from 'react';

function MechanicEmojiIcon({ emoji, className }) {
  return <span className={`${className} emoji-icon`} role="img">{emoji}</span>;
}

export const mechanicIcons = {
  all: <MechanicEmojiIcon emoji="🎮" className="mechanic-filter-icon" />,
  quiz: <MechanicEmojiIcon emoji="❓" className="mechanic-filter-icon" />,
  binary: <MechanicEmojiIcon emoji="⚡" className="mechanic-filter-icon" />,
  type: <MechanicEmojiIcon emoji="✏️" className="mechanic-filter-icon" />,
  unscramble: <MechanicEmojiIcon emoji="🔀" className="mechanic-filter-icon" />,
  sort: <MechanicEmojiIcon emoji="📊" className="mechanic-filter-icon" />,
  match: <MechanicEmojiIcon emoji="🔗" className="mechanic-filter-icon" />,
  sequence: <MechanicEmojiIcon emoji="📝" className="mechanic-filter-icon" />,
  swipe: <MechanicEmojiIcon emoji="👆" className="mechanic-filter-icon" />,
  hangman: <MechanicEmojiIcon emoji="🎯" className="mechanic-filter-icon" />,
  memory: <MechanicEmojiIcon emoji="🃏" className="mechanic-filter-icon" />,
  chain: <MechanicEmojiIcon emoji="⛓️" className="mechanic-filter-icon" />,
  puzzle: <MechanicEmojiIcon emoji="🧩" className="mechanic-filter-icon" />,
};

export const gameCardMechanicIcons = {
  quiz: <MechanicEmojiIcon emoji="❓" className="game-card-mechanic-icon" />,
  binary: <MechanicEmojiIcon emoji="⚡" className="game-card-mechanic-icon" />,
  type: <MechanicEmojiIcon emoji="✏️" className="game-card-mechanic-icon" />,
  unscramble: <MechanicEmojiIcon emoji="🔀" className="game-card-mechanic-icon" />,
  sort: <MechanicEmojiIcon emoji="📊" className="game-card-mechanic-icon" />,
  match: <MechanicEmojiIcon emoji="🔗" className="game-card-mechanic-icon" />,
  sequence: <MechanicEmojiIcon emoji="📝" className="game-card-mechanic-icon" />,
  swipe: <MechanicEmojiIcon emoji="👆" className="game-card-mechanic-icon" />,
  hangman: <MechanicEmojiIcon emoji="🎯" className="game-card-mechanic-icon" />,
  memory: <MechanicEmojiIcon emoji="🃏" className="game-card-mechanic-icon" />,
  chain: <MechanicEmojiIcon emoji="⛓️" className="game-card-mechanic-icon" />,
  puzzle: <MechanicEmojiIcon emoji="🧩" className="game-card-mechanic-icon" />,
};
